import { Component, Input } from "@angular/core";

@Component({
	selector: "app-usage-bar",
	templateUrl: "./usage-bar.component.html",
	styleUrls: ["./usage-bar.component.scss"],
})
export class UsageBarComponent {
	@Input()
	maxAmt = 1;

	@Input()
	currentAmt = 1;

	@Input()
	label: string;
}
